import { ApiRoutes, Routes } from '@/settings/routes';
import { App_text } from '@/settings/AppText';
import Link from 'next/link';
import React, { Fragment } from 'react';

export default function CardTopDeal({ data, postType }) {
    // Determine image alt text with proper fallback
    const imageAlt = data?.title
        ? `${data.title} - ${App_text.APP_NAME} ${postType === 'tours' ? 'tour' : 'package'}`
        : `Featured ${postType === 'tours' ? 'tour' : 'package'} by ${App_text.APP_NAME}`;

    return (
        <Fragment>
            <hr className="my-4" />
            <div className="flex gap-4 group">
                <Link prefetch={false} href={`/${postType === 'tours' ? postType : 'packages'}/${data?.slug}`} className="relative w-20 h-20 overflow-hidden rounded">
                    <img
                        className="object-cover transition-transform duration-500 ease-in-out size-full group-hover:scale-105"
                        src={data?.thumbnail?.url ? ApiRoutes.ASSETS_ENDPOINT + data?.thumbnail?.url : '/media/tour-06.jpg'}
                        width={80}
                        height={80}
                        loading="lazy"
                        decoding="async"
                        alt={imageAlt}
                    />
                </Link>
                <div className="flex flex-col justify-center gap-1">
                    <Link prefetch={false} href={`/${postType === 'tours' ? postType : 'packages'}/${data?.slug}`}>
                        <h4 className="text-base font-semibold default-color-title">{data.title}</h4>
                    </Link>
                    {data?.has_promo === 1 ? (
                        <div className="flex items-center gap-2 text-sm font-semibold text-gray-500">
                            <span className="text-base text-main-color">${data?.price_promo}</span>
                            <span className="line-through">${data?.price}</span>
                        </div>
                    ) : (
                        <div className="flex items-center gap-2 text-sm font-semibold text-gray-500">
                            <span className="text-base text-main-color">${data?.price}</span>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
}
